import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Snackbar from 'material-ui/Snackbar';
import Form from './Form';
import { success } from '../../actions/clientproduct/create';
import { retrieve, update, reset } from '../../actions/clientproduct/update';
import { del, loading, error } from '../../actions/clientproduct/delete';
import { list as retrieveClientProductOptions } from './../../actions/clientproductoption/list';
import { retrieve as retrieveClientProductStyle } from './../../actions/clientproductstyle/show';
import { decodeCssString } from './../../actions/clientproduct/update';
import { betfairAppStyleFields } from '../../constants';
import { literals } from './../../languages';

class Update extends Component {
  static propTypes = {
    retrieveError: PropTypes.string,
    retrieveLoading: PropTypes.bool.isRequired,
    updateError: PropTypes.string,
    updateLoading: PropTypes.bool.isRequired,
    deleteError: PropTypes.string,
    deleteLoading: PropTypes.bool.isRequired,
    retrieved: PropTypes.object,
    updated: PropTypes.object,
    deleted: PropTypes.object,
    retrieve: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
    del: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor(props){
    super(props);
    this.state = {
      showUpdateMsg: false
    }
  }

  componentWillMount() {
    this.props.retrieve(this.props.id);
    this.props.retrieveClientProductOptions();
  }

  componentWillReceiveProps(next){
    if (this.props.id !== next.id) {
      this.props.reset();
      this.props.retrieve(next.id);
      this.props.retrieveClientProductOptions();
    }
  }

  componentDidUpdate(prevProps, prevState){
    if (prevProps.updated !== this.props.updated) {
      this.setState({
        'showUpdateMsg': this.props.updated
      });
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  del = () => {
    if (window.confirm(literals.deleteWarningMessage[this.props.locale])) this.props.del(this.props.retrieved);
  };

  render() {
    let item = this.props.item;
    if (this.props.clientProductFormValues.clientProductStyles && this.props.clientProductFormValues.clientProductStyles.length && item) {
      let cssFields = decodeCssString(this.props.clientProductFormValues.clientProductStyles[0].styleValue);
      //append style values in form
      cssFields.forEach( v => {
        let fieldKey = Object.keys(v)[0];
        let fieldValue = v[fieldKey];
        item[fieldKey] = fieldValue;
      })
    }
    if (item && !item.hasOwnProperty(betfairAppStyleFields(this.props.locale).font.value)) {
      item[betfairAppStyleFields(this.props.locale).font.value] = betfairAppStyleFields(this.props.locale).font.defaultValue
    }

    return <div>
      <Snackbar
        open={Boolean(this.state.showUpdateMsg)}
        message={this.props.locale ? <div>{literals.updateSuccessMessage[this.props.locale]}<i style={{marginLeft:'15px'}}className="fa fa-check"></i></div> : ''}
        autoHideDuration={4000}
        bodyStyle={{backgroundColor:'teal'}}
        contentStyle={{color:'white'}}
        onRequestClose={()=>{this.setState({'showUpdateMsg': false})}}
      />
      {!(this.props.listLoading || this.props.retrieveLoading || this.props.updateLoading) && <h1 className="product-title">{item && item.product.name}</h1>}
      {this.props.created && <div className="alert alert-success" role="status">{this.props.created['@id']} created.</div>}
      {this.props.updated && <div className="alert alert-success" role="status">{/*this.props.updated['@id']*/}{literals.updateSuccessMessage[this.props.locale]}</div>}
      {(this.props.listLoading || this.props.retrieveLoading || this.props.updateLoading || this.props.deleteLoading) && <div className="alert alert-info" role="status">{literals.loadingMessage[this.props.locale]}</div>}
      {this.props.retrieveError && <div className="alert alert-danger" role="alert"><span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {this.props.retrieveError}</div>}
      {this.props.updateError && <div className="alert alert-danger" role="alert"><span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {this.props.updateError}</div>}
      {this.props.deleteError && <div className="alert alert-danger" role="alert"><span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {this.props.deleteError}</div>}

      {!this.props.listLoading && item &&
        <Form
          clientId={this.props.clientId}
          productId={item.product.id}
          clientProductId={this.props.id}
          formValues={this.props.clientProductFormValues}
          onSubmit={values => this.props.update(item, values)}
          initialValues={item}
          updateLoading = {this.props.updateLoading}
          locale={this.props.locale}
          isColorPickersVisible={this.props.isColorPickersVisible}
        />
      }
    </div>;
  }
}

const mapStateToProps = (state) => {
  const item = state.clientproduct.update.updated ? state.clientproduct.update.updated : state.clientproduct.update.retrieved;

  if (item && item.clientProductOptions.length) {
    item.clientProductOptions.forEach( v => {
      item[v.productOption['@id']] = v.optionValue
    })
  }

  return {
    retrieveError: state.clientproduct.update.retrieveError,
    retrieveLoading: state.clientproduct.update.retrieveLoading,
    listLoading: state.clientproductoption.list.loading,
    updateError: state.clientproduct.update.updateError,
    updateLoading: state.clientproduct.update.updateLoading,
    deleteError: state.clientproduct.del.error,
    deleteLoading: state.clientproduct.del.loading,
    created: state.clientproduct.create.created,
    deleted: state.clientproduct.del.deleted,
    retrieved: state.clientproduct.update.retrieved,
    updated: state.clientproduct.update.updated,
    clientProductFormValues: state.form.clientproduct ? state.form.clientproduct.values : {},
    item
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    retrieve: id => dispatch(retrieve(id)),
    update: (item, values) => dispatch(update(item, values)),
    del: item => dispatch(del(item)),
    retrieveClientProductOptions: () => dispatch(retrieveClientProductOptions()),
    retrieveClientProductStyle: (id) => dispatch(retrieveClientProductStyle(id)),
    reset: () => {
      dispatch(reset());
      dispatch(error(null));
      dispatch(loading(false));
      dispatch(success(null));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Update);



// WEBPACK FOOTER //
// ./src/components/clientproduct/Update.js